// src/data/liveApps.js
// Shared by the desktop and mobile Live Apps views.
export const liveAppsData = [
  {
    title: 'INSTAEVALUATE',
    links: [
      { platform: 'Web', url: 'https://instaevaluate.com/' },
    ],
  },
  {
    title: 'FIELD EXPRESS',
    links: [
      { platform: 'Play Store', url: 'https://play.google.com/store/apps/details?id=com.subsidex.fieldxpress&hl=en&pli=1' },
      { platform: 'App Store', url: 'https://apps.apple.com/in/app/fieldxpress/id6450364225' },
    ],
  },
  {
    title: 'SURGEONS FOR SURGEONS',
    links: [
      { platform: 'Play Store', url: 'https://play.google.com/store/apps/details?id=com.sfs_mobile_app&hl=en' },
      { platform: 'App Store', url: 'https://apps.apple.com/in/app/surgeons-for-surgeons/id1660956060' },
    ],
  },
  {
    title: 'SCHOOL MANAGEMENT',
    links: [
      { platform: 'Play Store', url: 'https://play.google.com/store/apps/details?id=com.natkhat.school_management_system&hl=en' },
    ],
  },
  {
    title: 'E LEARNING (CloudyML)',
    links: [
      { platform: 'Play Store', url: 'https://play.google.com/store/apps/details?id=com.cloudyml.cloudymlapp' },
      { platform: 'App Store', url: 'https://apps.apple.com/in/app/cloudyml-data-science-course/id6444130328' },
    ],
  },
  {
    title: 'Heyuva',
    links: [
      { platform: 'Play Store', url: 'https://play.google.com/store/apps/details?id=com.theyoungindians.android' },
    ],
  },
  {
    title: 'Taskforce HRM',
    links: [
      { platform: 'Play Store', url: 'https://play.google.com/store/apps/details?id=ca.conceptdash.taskforce&pcampaignid=web_share' },
    ],
  },
  {
    title: 'Taskforce Construction',
    links: [
      { platform: 'Play Store', url: 'https://play.google.com/store/apps/details?id=com.tf_construction.mobile&pcampaignid=web_share' },
    ],
  },
  {
    title: 'Taskforce One',
    links: [
      { platform: 'Play Store', url: 'https://play.google.com/store/apps/details?id=com.taskforce.one&pcampaignid=web_share' },
    ],
  },
];

export const LIVEAPPS_FILTERS = ['All', 'Web', 'Play Store', 'App Store'];
